import React from 'react';
import { roles } from '@nxsys/store/constants';
import Dashboard from '../../../modules/dashboard';
import { AnalyticsFilterProvider } from '../../../modules/analytics/context/AnalyticsFilterContext';

const Analytics = React.lazy(() => import('../../../modules/analytics'));

const allRoles = [roles.admin, roles.agency, roles.employee, roles.employer];

export const dashboardConfig = [
  {
    permittedRole: allRoles,
    path: '/dashboards',
    element: <Dashboard />,
  },
  {
    permittedRole: allRoles,
    path: '/analytics',
    element: (
      <AnalyticsFilterProvider>
        <Analytics />
      </AnalyticsFilterProvider>
    ),
  },
];
